(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Homepage-slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.hero-slider', {
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"> 0' + (index + 1) + " </span>";
        },
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      speed: 600,
    });
  });

  } catch(e) { console.error(e); }
})();
})();
